// extracted by mini-css-extract-plugin
export default {"wrapper":"InputControl_wrapper__R4RjS"};